"use client";

import React from "react";
import { Quote, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * SolutionForAgenciesAndFreelancers — Section 7: Testimonial
 * Drop-in für: src/pages/SolutionForAgenciesAndFreelancers/sections/WhatOurCommunitySays.tsx
 */

export default function WhatOurCommunitySays() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-3xl mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Quote className="w-10 h-10 text-primary/20 mx-auto mb-6 rotate-180" strokeWidth={1.5} />

        <p className="text-2xl md:text-3xl font-medium italic text-foreground leading-relaxed mb-8">
          «Wir betreuen über 15 KMU-Kunden über PAGEMAKER24. Ein Dashboard,
          alles im Griff. Das spart uns enorm viel Zeit — und die Marge stimmt.»
        </p>

        <div className="flex items-center justify-center gap-1 text-primary mb-4">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
        </div>

        <div>
          <span className="font-bold text-foreground">Sarah Steiner</span>
          <span className="text-muted-foreground mx-2">·</span>
          <span className="text-muted-foreground">
            Inhaberin Web-Agentur, Winterthur
          </span>
        </div>
      </div>
    </section>;
}